import React, { useState, useEffect } from "react";
import { Save } from "lucide-react";
import { API_BASE_URL, authHeaders } from "../../api";

const emptyAboutMe = {
    aboutme: {
        first: "",
        secand: "",
        third: ""
    },
    knollage: {
        experice: ""
    },
    contact: {
        mail: "",
        phone: ""
    }
};

function AdminAboutme() {
    const [aboutMe, setAboutMe] = useState(emptyAboutMe);
    const [status, setStatus] = useState("");

    useEffect(() => {
        getAboutMe();
    }, []);

    const getAboutMe = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/aboutme`, {
                headers: authHeaders(),
            });

            const data = await response.json();
            setAboutMe({ ...emptyAboutMe, ...data });
        } catch (error) {
            console.error("Fehler beim Abrufen der About Me Daten:", error);
        }
    };

    const updateAboutText = (field, value) => {
        setAboutMe((current) => ({
            ...current,
            aboutme: {
                ...current.aboutme,
                [field]: value
            }
        }));
    };

    const updateKnowledge = (value) => {
        setAboutMe((current) => ({
            ...current,
            knollage: {
                ...current.knollage,
                experice: value
            }
        }));
    };

    const updateContact = (field, value) => {
        setAboutMe((current) => ({
            ...current,
            contact: {
                ...current.contact,
                [field]: value
            }
        }));
    };

    const saveAboutMe = async () => {
        setStatus("Speichert...");

        try {
            const response = await fetch(`${API_BASE_URL}/api/aboutme`, {
                method: "PUT",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(aboutMe)
            });

            if (!response.ok) {
                throw new Error("Speichern fehlgeschlagen");
            }

            setStatus("Gespeichert");
        } catch (error) {
            console.error(error);
            setStatus("Fehler beim Speichern");
        }
    };

    return (
        <div className="action-card">
            <h3>About Me</h3>
            <div className="action-card-body">
                <label className="field-label" htmlFor="about-first">Absatz 1</label>
                <textarea
                    id="about-first"
                    className="textarea"
                    value={aboutMe.aboutme.first}
                    onChange={(event) => updateAboutText("first", event.target.value)}
                    style={{ height: "150px" }}
                />
                <label className="field-label" htmlFor="about-second">Absatz 2</label>
                <textarea
                    id="about-second"
                    className="textarea"
                    value={aboutMe.aboutme.secand}
                    onChange={(event) => updateAboutText("secand", event.target.value)}
                    style={{ height: "150px" }}
                />
                <label className="field-label" htmlFor="about-third">Absatz 3</label>
                <textarea
                    id="about-third"
                    className="textarea"
                    value={aboutMe.aboutme.third}
                    onChange={(event) => updateAboutText("third", event.target.value)}
                    style={{ height: "120px" }}
                />
                <label className="field-label" htmlFor="about-experience">Erfahrungen</label>
                <textarea
                    id="about-experience"
                    className="textarea"
                    value={aboutMe.knollage.experice}
                    onChange={(event) => updateKnowledge(event.target.value)}
                    style={{ height: "150px" }}
                />
                <div className="form-grid">
                    <label className="field-label" htmlFor="about-mail">E-Mail</label>
                    <input
                        id="about-mail"
                        className="text-input"
                        type="email"
                        value={aboutMe.contact.mail}
                        onChange={(event) => updateContact("mail", event.target.value)}
                    />
                    <label className="field-label" htmlFor="about-phone">Telefon</label>
                    <input
                        id="about-phone"
                        className="text-input"
                        type="tel"
                        value={aboutMe.contact.phone}
                        onChange={(event) => updateContact("phone", event.target.value)}
                    />
                </div>
                <div className="admin-actions">
                    <button type="button" className="btn btn-success icon-label-button" onClick={saveAboutMe}>
                        <Save size={18} />
                        Speichern
                    </button>
                    {status && <span className="save-status">{status}</span>}
                </div>

            </div>
        </div>
    );
}

export default AdminAboutme;
